import React from "react";
import Layout from "../components/Layout";

function Roadmap() {
  const roadmapPhases = [
    {
      quarter: "Q1-Q3 2025",
      title: "Foundation & Core Platform (Completed)",
      status: "completed",
      color: "success",
      features: [
        {
          category: "Technology Modernization & Performance",
          items: [
            "React 19 migration enhancement with concurrent rendering ✓",
            "AWS to Google Cloud migration completion ✓",
            "PostgreSQL query optimization and connection pooling ✓",
            "Mobile-first UI redesign with Bootstrap 5.3+ ✓",
          ],
        },
        {
          category: "Advanced Analytics & Reporting",
          items: [
            "Executive dashboard with cross-vendor performance metrics ✓",
          ],
        },
        {
          category: "Core Integrations & Security",
          items: ["Enhanced HIPAA-compliant data encryption ✓"],
        },
      ],
      outcomes: [
        "99.9% uptime reliability achieved",
        "50% improvement in system performance",
        "75% reduction in manual administrative tasks",
      ],
    },
    {
      quarter: "Q4 2025",
      title: "Innovation & Advanced Mobile",
      status: "current",
      color: "primary",
      features: [
        // {
        //   category: "Advanced Mobile Capabilities",
        //   items: ["Advanced photo/video documentation tools"],
        // },
        {
          category: "Core Integrations",
          items: ["Invoice Creation", "Improve Notes"],
        },
        // {
        //   category: "AI-Powered Features",
        //   items: ["Voice-to-text integration for mobile service logging"],
        // },
        {
          category: "Reports",
          items: [
            "CRP-21 (Communicty Based Assessment)",
            "CRP-30 (Job Placement Plan)",
            "CRP-31 (Placement Services Assessment",
            "CRP-32 (Job Placement Follow-Up)",
            "CRP-33 (Job Search Data Sheet)",
          ],
        },
      ],
      outcomes: [
        "25% improvement in consumer outcomes",
        "Enhanced consumer satisfaction scores",
        "Competitive differentiation in market",
      ],
    },
    // {
    //   quarter: "Q1 2026",
    //   title: "AI-Powered Features & Enterprise Integration",
    //   status: "planned",
    //   color: "warning",
    //   features: [
    //     {
    //       category: "AI-Powered Features",
    //       items: [
    //         "Smart progress notes with natural language processing",
    //         "Consumer risk assessment using machine learning",
    //         "AI-generated monthly CRP reports with insights",
    //         "Voice-to-text integration for mobile service logging",
    //       ],
    //     },
    //     {
    //       category: "Advanced Integration Capabilities",
    //       items: [
    //         "Third-party EHR integration with FHIR compliance",
    //         "Government reporting automation for state systems",
    //         "Financial system integration (QuickBooks, SAP)",
    //         "Single Sign-On (SSO) with SAML/OAuth2 support",
    //       ],
    //     },
    //     {
    //       category: "Native Mobile & Enhanced Security",
    //       items: [
    //         "Dedicated iOS/Android app with offline capabilities",
    //         "Advanced audit analytics with AI-powered pattern detection",
    //         "Zero-trust security model with micro-segmentation",
    //         "Blockchain document verification for compliance integrity",
    //       ],
    //     },
    //   ],
    //   outcomes: [
    //     "60% reduction in documentation time through AI assistance",
    //     "Seamless integration with existing enterprise systems",
    //     "Industry-leading security and compliance standards",
    //   ],
    // },
    // {
    //   quarter: "Q2 2026",
    //   title: "Enterprise Scale & Business Intelligence",
    //   status: "future",
    //   color: "info",
    //   features: [
    //     {
    //       category: "User Experience & Accessibility",
    //       items: [
    //         "Full WCAG 2.2 accessibility compliance",
    //         "Multi-language support (Spanish and others)",
    //         "Advanced search with Elasticsearch integration",
    //         "Customizable workflows for different organizations",
    //       ],
    //     },
    //     {
    //       category: "Business Intelligence & Growth",
    //       items: [
    //         "Evidence-based practice tracking with outcome measures",
    //         "Industry benchmarking and performance comparison tools",
    //         "API marketplace with developer portal",
    //         "White-label solutions for enterprise customers",
    //       ],
    //     },
    //     {
    //       category: "System Reliability & Scalability",
    //       items: [
    //         "Microservices architecture implementation",
    //         "Advanced monitoring with predictive alerting",
    //         "Multi-region disaster recovery enhancement",
    //         "Comprehensive load testing and optimization",
    //       ],
    //     },
    //   ],
    //   outcomes: [
    //     "Support for 100+ enterprise organizations",
    //     "Industry leadership in outcome measurement",
    //     "Scalable architecture for unlimited growth",
    //   ],
    // },
    // {
    //   quarter: "Q3 2026",
    //   title: "Market Leadership & Innovation",
    //   status: "future",
    //   color: "dark",
    //   features: [
    //     {
    //       category: "Next-Generation Features",
    //       items: [
    //         "Advanced machine learning for outcome optimization",
    //         "Integrated virtual reality training modules",
    //         "IoT integration for workplace monitoring",
    //         "Quantum-resistant encryption implementation",
    //       ],
    //     },
    //     {
    //       category: "Ecosystem Integration",
    //       items: [
    //         "Job board and employer relationship management",
    //         "Skills assessment and AI-powered job matching",
    //         "Transportation coordination and logistics",
    //         "Social services network integration",
    //       ],
    //     },
    //     {
    //       category: "Advanced Analytics Platform",
    //       items: [
    //         "Real-time market intelligence dashboard",
    //         "Competitive analysis and benchmarking suite",
    //         "Regulatory compliance automation across all states",
    //         "Advanced financial forecasting and budgeting tools",
    //       ],
    //     },
    //   ],
    //   outcomes: [
    //     "Market leader position in CRP technology",
    //     "50% improvement in employment placement rates",
    //     "Platform ecosystem with 500+ integrations",
    //   ],
    // },
  ];

  const kpis = [
    {
      category: "Technical",
      metrics: [
        { name: "System uptime", target: "99.9%" },
        { name: "Page load time", target: "<2 seconds" },
        { name: "Mobile app crash rate", target: "<0.1%" },
        { name: "API response time", target: "<200ms" },
      ],
    },
    {
      category: "Business",
      metrics: [
        { name: "Customer retention rate", target: ">95%" },
        { name: "Net Promoter Score", target: ">70" },
        { name: "Time-to-value", target: "<30 days" },
        { name: "Support ticket resolution", target: "<24 hours" },
      ],
    },
    {
      category: "Impact",
      metrics: [
        { name: "Customer time savings", target: ">40%" },
        { name: "Billing accuracy improvement", target: ">90%" },
        { name: "Compliance score improvement", target: ">85%" },
        { name: "Consumer outcome improvements", target: ">20%" },
      ],
    },
  ];

  return (
    <Layout>
      <div className="min-vh-100 d-flex flex-column">
        {/* Navbar */}
        {/* <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top">
        <div className="container">
          <a className="navbar-brand fw-bold" href="/">
            <i className="bi bi-layers me-2"></i>
            WebVenly
          </a>
          <div className="d-flex">
            <a href="/" className="btn btn-outline-light">
              <i className="bi bi-arrow-left me-2"></i>
              Back to Home
            </a>
          </div>
        </div>
      </nav> */}

        {/* Hero Section */}
        <section className="bg-gradient-primary text-white py-5">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8 mx-auto text-center">
                <h1 className="display-4 fw-bold mb-4">Product Roadmap</h1>
                <p className="lead mb-4">
                  Our commitment to continuous innovation and excellence in CRP
                  management technology
                </p>
                <div className="d-flex justify-content-center gap-3 flex-wrap">
                  <div className="badge bg-primary bg-opacity-75 px-3 py-2">
                    <i className="bi bi-calendar-check me-2"></i>
                    Updated Monthly
                  </div>
                  <div className="badge bg-success bg-opacity-75 px-3 py-2">
                    <i className="bi bi-people me-2"></i>
                    Customer-Driven
                  </div>
                  <div className="badge bg-warning bg-opacity-75 px-3 py-2">
                    <i className="bi bi-shield-check me-2"></i>
                    Compliance-First
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Timeline Section */}
        <section className="py-5">
          <div className="container">
            <div className="row">
              {roadmapPhases.map((phase, index) => (
                <div className="col-lg-6 mb-5" key={index}>
                  <div className={`card h-100 border-${phase.color} shadow-sm`}>
                    <div className={`card-header bg-${phase.color} text-white`}>
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <h4 className="mb-1">{phase.quarter}</h4>
                          <h5 className="mb-0">{phase.title}</h5>
                        </div>
                        <div className="text-end">
                          {phase.status === "current" && (
                            <span className="badge bg-light text-dark">
                              <i className="bi bi-play-fill me-1"></i>
                              In Progress
                            </span>
                          )}
                          {phase.status === "planned" && (
                            <span className="badge bg-light text-dark">
                              <i className="bi bi-clock me-1"></i>
                              Planned
                            </span>
                          )}
                          {phase.status === "future" && (
                            <span className="badge bg-light text-dark">
                              <i className="bi bi-lightbulb me-1"></i>
                              Future
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="card-body">
                      {phase.features.map((feature, fIndex) => (
                        <div className="mb-4" key={fIndex}>
                          <h6
                            className={`text-${phase.color} fw-semibold mb-2`}
                          >
                            <i className="bi bi-gear me-2"></i>
                            {feature.category}
                          </h6>
                          <ul className="list-unstyled ms-3">
                            {feature.items.map((item, iIndex) => (
                              <li className="mb-1 small" key={iIndex}>
                                <i
                                  className={`bi bi-check-circle-fill text-${phase.color} me-2`}
                                ></i>
                                {item}
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}

                      <div
                        className={`bg-${phase.color} bg-opacity-10 rounded p-3 mt-4`}
                      >
                        <h6 className={`text-${phase.color} mb-2`}>
                          <i className="bi bi-target me-2"></i>
                          Expected Outcomes
                        </h6>
                        <ul className="list-unstyled mb-0">
                          {phase.outcomes.map((outcome, oIndex) => (
                            <li className="small mb-1" key={oIndex}>
                              <i
                                className={`bi bi-arrow-right text-${phase.color} me-2`}
                              ></i>
                              {outcome}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* KPIs Section */}
        <section className="py-5 bg-gradient-light">
          <div className="container">
            <div className="text-center mb-5">
              <h2 className="display-6 fw-bold mb-3">Success Metrics & KPIs</h2>
              <p className="lead text-muted">
                How we measure progress and success
              </p>
            </div>

            <div className="row g-4">
              {kpis.map((category, cIndex) => (
                <div className="col-lg-4" key={cIndex}>
                  <div className="card h-100 shadow-sm">
                    <div className="card-header bg-white border-bottom-0">
                      <h5 className="mb-0 text-center">
                        <i className="bi bi-bar-chart me-2 text-primary"></i>
                        {category.category} Metrics
                      </h5>
                    </div>
                    <div className="card-body">
                      {category.metrics.map((metric, mIndex) => (
                        <div
                          className="d-flex justify-content-between align-items-center py-2 border-bottom"
                          key={mIndex}
                        >
                          <span className="small fw-medium">{metric.name}</span>
                          <span className="badge bg-primary bg-opacity-10 text-primary">
                            {metric.target}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Investment Section */}
        <section className="py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="text-center mb-5">
                  <h2 className="display-6 fw-bold mb-3">
                    Investment & Growth
                  </h2>
                  <p className="lead text-muted">
                    Our commitment to platform excellence
                  </p>
                </div>

                <div className="row g-4">
                  <div className="col-md-4">
                    <div className="card text-center h-100 shadow-sm">
                      <div className="card-body">
                        <div
                          className="bg-primary bg-opacity-10 rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                          style={{ width: "60px", height: "60px" }}
                        >
                          <i className="bi bi-people text-primary fs-4"></i>
                        </div>
                        <h5 className="fw-bold mb-2">Development Team</h5>
                        <p className="text-muted small mb-3">
                          Scaling from 5 to 12 specialists
                        </p>
                        <ul className="list-unstyled small text-start">
                          <li className="mb-1">• Mobile developers</li>
                          <li className="mb-1">• Backend engineers</li>
                          <li className="mb-1">• AI/ML specialists</li>
                          <li className="mb-1">• Integration experts</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="card text-center h-100 shadow-sm">
                      <div className="card-body">
                        <div
                          className="bg-success bg-opacity-10 rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                          style={{ width: "60px", height: "60px" }}
                        >
                          <i className="bi bi-cloud text-success fs-4"></i>
                        </div>
                        <h5 className="fw-bold mb-2">Infrastructure</h5>
                        <p className="text-muted small mb-3">
                          Enterprise-grade platform
                        </p>
                        <ul className="list-unstyled small text-start">
                          <li className="mb-1">• Cloud hosting scalability</li>
                          <li className="mb-1">• Enhanced security measures</li>
                          <li className="mb-1">• Backup & disaster recovery</li>
                          <li className="mb-1">• Performance monitoring</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="card text-center h-100 shadow-sm">
                      <div className="card-body">
                        <div
                          className="bg-warning bg-opacity-10 rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                          style={{ width: "60px", height: "60px" }}
                        >
                          <i className="bi bi-graph-up text-warning fs-4"></i>
                        </div>
                        <h5 className="fw-bold mb-2">Investment</h5>
                        <p className="text-muted small mb-3">
                          Committed funding for growth
                        </p>
                        <div className="text-start">
                          <div className="d-flex justify-content-between small mb-2">
                            <span>2025 Annual:</span>
                            <span className="fw-semibold">$600K - $800K</span>
                          </div>
                          <div className="d-flex justify-content-between small">
                            <span>Growth (18mo):</span>
                            <span className="fw-semibold">$1M - $1.5M</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section bg-gradient-primary text-white py-5">
          <div className="container text-center">
            <h2 className="display-5 fw-bold mb-3">
              Want to Shape Our Roadmap?
            </h2>
            <p className="lead mb-4">
              Your feedback drives our development priorities. Join our customer
              advisory board and help us build the future of CRP management.
            </p>
            <div className="cta-buttons">
              <a href="/demo" className="btn btn-light btn-lg me-3">
                <i className="bi bi-calendar-check me-2"></i>
                Schedule a Demo
              </a>
              <a href="/contact" className="btn btn-outline-light btn-lg">
                <i className="bi bi-chat-dots me-2"></i>
                Share Your Input
              </a>
            </div>
            <p className="mt-4 mb-0 text-white-75">
              <small>
                Customer-driven development • Transparent roadmap • Regular
                updates
              </small>
            </p>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-dark text-white py-4 mt-auto">
          <div className="container text-center">
            <p className="mb-1">
              &copy; {new Date().getFullYear()} WebVenly. All rights reserved.
            </p>
            <p className="mb-0 small text-light">
              Powered by <strong>Wyatt Multi Solutions</strong>
            </p>
          </div>
        </footer>
      </div>
    </Layout>
  );
}

export default Roadmap;
